// extracted by mini-css-extract-plugin
export var backdrop = "_gx-1";
export var dragging = "_gx-4";
export var handle = "_gx-6";
export var handleHit = "_gx-5";
export var listEnd = "_gx-8";
export var modalRoot = "_gx-0";
export var sectionHeader = "_gx-a";
export var sheet = "_gx-3";
export var sheetHost = "_gx-2";
export var shortcutColumns = "_gx-7";
export var shortcutSection = "_gx-9";